//import liraries
import React, {  useEffect, useState } from "react";
import { View,  ScrollView, FlatList } from "react-native";
import CHeader from "../../common/CHeader";
import { CreateResponsiveStyle } from "rn-responsive-styles";
import CText from "../../common/CText";
import {  duplicateDisute  } from "../../api/apiManager";
import CustomButton from "../../common/CustomButton";
import { COLORS, FONTS } from "../../constant";
import CImage from "../../common/CImage";
import { isEmpty } from "lodash";
import Loader from "../../common/Loader";

// create a component
const DuplicateDisputeLList = (props) => {
  const headingData = [
    {
      id: 1,
      title: "Vehicle No.",
      width: 145
    },
    {
      id: 2,
      title: "TXN DATE",
      width: 145
    },
    {
      id: 3,
      title: "TXN TIME",
      width: 145
    },
    {
      id: 4,
      title: "TXN ID",
      width: 145
    },
    {
      id: 5,
      title: "TXN TYPE",
      width: 185
    },
    {
      id: 6,
      title: "PLAZA NAME",
      width: 185
    },
    
    {
      id: 7,
      title: "DEBIT AMOUNT",
      width: 145
    },
    {
      id: 8,
      title: "CREDIT AMOUNT",
      width: 145
    },
    {
      id: 9,
      title: "BALANCE AMOUNT",
      width: 145
    },
    {
      id: 10,
      title: "ACTIONS",
      width: 145
    },
  ];

  const styles = useStyles();
  const [loading, setLoading] = useState(false)
  const [transactionData, setTransactionData] = useState()

  const getStatement = () => {
    const params={
      "txnDate" : props?.date,
      "disputeTypeId" : props?.reasonID,
      "amount" :  props?.amount,
      "txnId":props?.txnId,
      "vrn" :  props?.vrn
    }
    setLoading(true);
    duplicateDisute(params).then(res => {
      setLoading(false);
      setTransactionData(res.data);
    }).catch((err) => {
      setLoading(false);
    });
  };

  useEffect(() => {
    getStatement()
  }, [])
  return (
      <View style={styles.contentWrapper}>
        <CHeader
          showBack
          disputeHeader
          title="Select a dispute"
          onPress={() => props.setIsListUi(false)}
          showDesc={true}
        />
        {
          isEmpty(transactionData)
            ? <View style={{ alignItems: "center", justifyContent: "center", marginTop: 40, }}>
              <CImage.Ti24SCancelImage />
              <CText.kycTypeText
                style={{ color: COLORS.black, paddingVertical: 20 }}
              >
                {"No Transactions Found"}
              </CText.kycTypeText>
              <CText.kycTypeText
                style={{
                  color: COLORS.black,
                  paddingBottom: 20,
                  opacity: 0.5,
                  fontFamily: FONTS.InterMedium,
                  paddingHorizontal: 60,
                  textAlign: "center",
                }}
              >
                {
                  "Sorry, no disputes were found on your account"
                }
              </CText.kycTypeText>
            </View>
            : <ScrollView horizontal={true}>

              <View style={{ width: "100%", borderRadius: 20 }}>
                <View style={styles.headerViewStyle}>
                  {headingData.map((item) => {
                    return (
                      <View style={styles.headerViewStyle}>
                        <CText.tiTransactionText style={{ width: item.width, minWidth: item.width }}>
                          {item.title}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                      </View>
                    );
                  })}
                </View>
                <FlatList
                  style={{}}
                  showsVerticalScrollIndicator
                  data={transactionData}
                  showsHorizontalScrollIndicator
                  keyExtractor={(item) => item.id}
                  renderItem={({ item, index }) => {
                    console.log(item, "transactionData")
                    return (
                      <View
                        style={[
                          styles.dataViewStyle,
                          {
                            backgroundColor:
                              index % 2 !== 0 ? "#ffffff" : "#E5E5E5",
                            borderBottomRightRadius: index == transactionData.length - 1 ? 15 : null,
                            borderBottomLeftRadius: index == transactionData.length - 1 ? 15 : null
                          },
                        ]}
                      >
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.vrn}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.dateTime?.split(" ")[0]}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.dateTime?.split(" ")[1]}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.transId}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 185, minWidth: 185 }}>
                          {item.transactionType}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 185, minWidth: 185 }}>
                          {item.tollPlaza}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.statementType == "D" ? item.price : "-"}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.statementType == "C" ? item.price : "-"}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <CText.tiTransactionText style={{ width: 145, minWidth: 145 }}>
                          {item.amountBalance}
                        </CText.tiTransactionText>
                        <View style={styles.verticalLineStyle} />
                        <View style={{ alignSelf: "center", paddingHorizontal: 10 }}>
                          <CustomButton onPress={() => {
                             props.setDuplicateDetails(item); props.setIsListUi(false)
                          }} skipButton text={"Select"} width={120} height={35} borderColor={COLORS.black} padding={7} />
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </ScrollView>
        }
 {loading && <Loader />}

      </View>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle({

  contentWrapper: {
    width: "100%",
    height: "100%",
  },
  headerViewStyle: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  verticalLineStyle: {
    width: 0.5,
    height: "100%",
    backgroundColor: "#a0a0a0",
  },
  dataViewStyle: {
    flexDirection: "row",
  },
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 10,
  },
});

//make this component available to the app
export default DuplicateDisputeLList;
